export default __webpack_public_path__ + "static/media/meetingconfirmed2.e663ce47.png";